import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { IResizerState } from './types';

const NS = 'resizerSlice';

const initialState: IResizerState = {
  width: 0,
};

const resizerSlice = createSlice({
  name: 'resizer', // used in action types
  initialState,
  reducers: {
    changedResizerWidth: (state: IResizerState, action: PayloadAction<{width: number;}>) => {
      state.width = action.payload.width;
    },
  },
});

// Extract the action creators object and the reducer
const { actions, reducer } = resizerSlice;
// Extract and export each action creator by name
export { actions as resizerActions };
// Export the reducer, either as a default or named export
export default reducer;
